// src/pages/b2c/MemberCard.jsx
import React from "react";
import { Box, Typography, Stack } from "@mui/material";

// Colors sampled from your SEHO logo (adjust if you want)
const SEHO_TEAL = "#0090A0";
const SEHO_ORANGE = "#F2961C";

const getDisplayName = (user) => {
  if (!user) return "-";
  const { firstName, lastName, name } = user || {};

  // Prefer new backend fields
  if (lastName || firstName) {
    if (lastName && firstName) return `${lastName}  ${firstName}`; // e.g. 張小明
    return lastName || firstName;
  }

  // Fallback to legacy "name"
  return name || "-";
};

export default function MemberCard({ user }) {
  const name = getDisplayName(user);
  const id = user?.userID || "-";
  const phone = user?.phoneNumber || "-";

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        bgcolor: SEHO_TEAL,
        color: "#fff",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        p: { xs: 2, sm: 2.5 },
        boxSizing: "border-box",
      }}
    >
      {/* Top: SEHO logo + orange line */}
      <Stack spacing={1}>
        <Typography
          sx={{
            fontFamily:
              '"LINE Sans TW","Noto Sans TC",system-ui,-apple-system,"Segoe UI",sans-serif',
            fontWeight: 900,
            letterSpacing: 2,
            fontSize: 18,
          }}
        >
          SEHO
        </Typography>

        <Box
          sx={{
            height: 4,
            bgcolor: SEHO_ORANGE,
            borderRadius: 999,
          }}
        />
      </Stack>

      {/* Main info area - only values, no labels */}
      <Box sx={{ mt: 2.5, flex: 1 }}>
        <Typography sx={{ fontSize: 18, fontWeight: 700, mb: 0.75 }}>
          {name}
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 0.5 }}>{phone}</Typography>
      </Box>

      {/* Bottom barcode area - single barcode with userID above it */}
      <Box
        sx={{
          mt: 1.5,
          bgcolor: "#fff",
          borderRadius: 1.5,
          height: 72,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: 2,
          boxSizing: "border-box",
        }}
      >
        {/* UserID text on top of barcode */}
        <Typography
          sx={{
            fontSize: 11,
            color: "#000",
            fontWeight: 600,
            mb: 0.5,
            whiteSpace: "nowrap",
          }}
        >
          {id}
        </Typography>

        {/* Barcode stripes */}
        <Box
          sx={{
            width: "100%",
            height: 28,
            backgroundImage:
              "repeating-linear-gradient(90deg, #000, #000 2px, #000 3px, transparent 3px, transparent 5px)",
          }}
        />
      </Box>
    </Box>
  );
}
